import {actionNames} from 'constants/index';
const mapDispatchToProps = dispatch => ({
    // STEPERS
    SOLICITUD_EMPADRONAMIENTO_EXTRANJERO_SET_STEP: (step) => dispatch({ "type": actionNames.SOLICITUD_EMPADRONAMIENTO_EXTRANJERO_SET_STEP, payload: step}),

    SOLICITUD_EMPADRONAMIENTO_SET_STEP_PORTAL_WEB: (stepPortalWeb)=> 
        dispatch({ "type":actionNames.SOLICITUD_EMPADRONAMIENTO_SET_STEP_PORTAL_WEB,"state":{"stepPortalWeb":stepPortalWeb}}),

// DATA
    SET_DATA_HOMONIMO_CIUDADANO: (data) => dispatch({ "type": actionNames.SET_DATA_HOMONIMO_CIUDADANO, payload: data}),
// DATA PORTAL WEB ---------------------------------
    SOLICITUD_EMPADRONAMIENTO_SET_DATOS_PORTAL_WEB: (datosPortalWeb)=> 
        dispatch({ "type":actionNames.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_PORTAL_WEB,"state":{"datosPortalWeb":datosPortalWeb}}),

    SOLICITUD_EMPADRONAMIENTO_SET_DATOS_CIUDADANO_TABLE: (datosCiudadanoTable)=> 
        dispatch({ "type":actionNames.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_CIUDADANO_TABLE,"state":{"datosCiudadanoTable":datosCiudadanoTable}}),

    SOLICITUD_EMPADRONAMIENTO_SET_CUI_DPI_PORTAL_WEB: (cuiDPISolicitudPortalWeb)=> 
        dispatch({ "type":actionNames.SOLICITUD_EMPADRONAMIENTO_SET_CUI_DPI_PORTAL_WEB,"state":{"cuiDPISolicitudPortalWeb":cuiDPISolicitudPortalWeb}}),          
// --------------------------------------------------------------------
    SOLICITUD_EMPADRONAMIENTO_SET_HOMONIMOS: (homonimos)=> 
        dispatch({ "type":actionNames.SOLICITUD_EMPADRONAMIENTO_SET_HOMONIMOS,"state":{"homonimos":homonimos}}),         
    DATOS_SOLICITUD_EXTRANJERO: (datosSolicitudExtranjero)=> 
        dispatch({ "type":actionNames.DATOS_SOLICITUD_EXTRANJERO,"state":{"datosSolicitudExtranjero":datosSolicitudExtranjero}}),     
    SET_CITIZEN_IDENTITY_DATA: (data) => dispatch({ "type": actionNames.SET_CITIZEN_IDENTITY_DATA, payload: data}),
    CLEAR_CITIZEN_IDENTITY_DATA: (data) => dispatch({ "type": actionNames.CLEAR_CITIZEN_IDENTITY_DATA}),
});
export default mapDispatchToProps;